import { Plugin } from 'ckeditor5';

export default class ImageLazyLoadPlugin extends Plugin {
    init() {
        const editor = this.editor;

        editor.model.schema.extend('imageBlock', {
            allowAttributes: ['loading']
        });

        editor.conversion.for('downcast').add(dispatcher => {
            dispatcher.on('attribute:loading:imageBlock', (evt, data, conversionApi) => {
                const viewWriter = conversionApi.writer;
                const viewElement = conversionApi.mapper.toViewElement(data.item);
                const viewImg = viewElement.getChild(0);

                if (viewImg && viewImg.is('element', 'img')) {
                    if (data.attributeNewValue !== null) {
                        viewWriter.setAttribute('loading', data.attributeNewValue, viewImg);
                    } else {
                        viewWriter.removeAttribute('loading', viewImg);
                    }
                }
            });
        });

        editor.conversion.for('upcast').attributeToAttribute({
            view: {
                name: 'img',
                key: 'loading'
            },
            model: 'loading'
        });

        // Set lazy load on all newly inserted images
        editor.model.document.on('change', () => {
            const root = editor.model.document.getRoot();
            for (const node of root.getChildren()) {
                if (node.name === 'imageBlock' && !node.getAttribute('loading')) {
                    editor.model.change(writer => {
                        writer.setAttribute('loading', 'lazy', node);
                    });
                }
            }
        });
    }
}
